import request from "root/js/request";

export const postSharesUpload = async ({ cabinet_id, shares_id }) => {
  const response = await request({
    url: `/api/analytics/shares/${shares_id}/shares_upload/?cabinet_id=${cabinet_id}`,
    method: "post",
  });
  return response;
};
